<template>
  <div class="product-config-wrap">
    <template v-if="isSetTemplate">
      <el-button type="info" :size="$store.state.buttonSize" @click="remove"
        >移除溯源模板</el-button
      >
    </template>
    <template v-else>
      <el-button
        v-show="isSetShow"
        type="primary"
        :display="true"
        :size="$store.state.buttonSize"
        @click="handleOpen"
        >溯源模板设置</el-button
      >
    </template>
    <el-row v-if="isSetTemplate" :gutter="20">
      <el-col
        :md="24"
        :lg="12"
        style="border-right:solid 1px #e5e5e5; min-height:400px"
      >
        <el-divider content-position="center">模板信息</el-divider>
        <div class="content-product-template">
          <table>
            <tr>
              <td class="list-item">溯源模板名称：</td>
              <td>{{ traceTemplateName }}</td>
            </tr>
            <tr>
              <td class="list-item">添加时间：</td>
              <td>{{ createTime }}</td>
            </tr>
            <tr>
              <td class="list-item">添加人：</td>
              <td>{{ creatorName }}</td>
            </tr>
            <tr>
              <td class="list-item">修改时间：</td>
              <td>{{ updateTime }}</td>
            </tr>
            <tr>
              <td class="list-item">修改人：</td>
              <td>{{ updatorName }}</td>
            </tr>
          </table>
        </div>
      </el-col>
      <el-col :md="24" :lg="12">
        <el-divider content-position="center">{{
          traceTemplateName
        }}</el-divider>
        <el-timeline style="height:60vh; overflow-y:auto">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            type="primary"
            color="#409EFF"
            size="large"
            :timestamp="activity.content"
            placement="top"
            style="line-height:22px"
            >
            <el-card>
              <h4>描述信息：{{ activity.itemDescribe }}</h4>
              <!-- <p>王小虎 提交于 2018/4/12 20:46</p> -->
            </el-card>
          </el-timeline-item>
          <el-timeline-item> </el-timeline-item>
        </el-timeline>
      </el-col>
    </el-row>

    <!-- 选择溯源模板弹窗：按当前产品所在分类过滤、仅显示启用状态的模板，单选后完成设置 -->
    <el-dialog
      title="选择溯源模版"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="60%"
      append-to-body
      center
    >
      <el-table
        v-loading="listLoading"
        :data="templateList"
        highlight-current-row
        height="400"
        @current-change="handleCurrentChange"
        @row-click="handleCurrentChange"
      >
        <el-table-column width="55" align="center">
          <template slot-scope="scope">
            <el-radio v-model="selectedId" :label="scope.row.id"><span></span></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="templateName" label="溯源模板名称"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status !== 0" type="success" size="small">启用</el-tag>
            <el-tag v-else type="info" size="small">停用</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="!selectedId" @click="handleConfirm">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import {
  putTraceTemplateProduct,
  getTraceTemplateProduct,
  getTraceTemplateList,
  deleteTraceTemplateProduct
} from '@/api/tracetemplate'
import { getProductDetail } from '@/api/product'

export default {
  props: {
    templateOptions: {
      type: Array,
      default() {
        return []
      }
    },
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      activities: [],
      traceTemplateName: '',
      createTime: '',
      creatorName: '',
      updateTime: '',
      updatorName: '',
      isSetTemplate: false,
      isSetShow: false,
      templateId: null,
      dialogVisible: false,
      listLoading: false,
      templateList: [],
      selectedId: null
    }
  },
  methods: {
    // 打开选择弹窗：加载当前产品所在分类下的启用状态模板
    handleOpen() {
      this.dialogVisible = true
      this.selectedId = null
      this.templateList = []
      getProductDetail(this.id).then(res => {
        const params = { page: 1, size: 1000, status: 1 }
        if (res.status === 1 && res.data) {
          const levels = ['categoryLevel1', 'categoryLevel2', 'categoryLevel3', 'categoryLevel4']
          levels.forEach(k => {
            if (res.data[k]) {
              params[k] = res.data[k]
            }
          })
        }
        this.listLoading = true
        getTraceTemplateList(params).then(r => {
          if (r.status === 1) {
            this.templateList = r.data.rows || []
          } else {
            this.$message.error(r.msg)
          }
          this.listLoading = false
        })
      })
    },
    // 单选（点击行或单选按钮）
    handleCurrentChange(row) {
      if (row) {
        this.selectedId = row.id
      }
    },
    // 确定：完成溯源模板设置
    handleConfirm() {
      if (!this.selectedId) {
        this.$message.warning('请先选择一个溯源模板')
        return
      }
      putTraceTemplateProduct({
        productId: this.id,
        traceTemplateId: this.selectedId
      }).then(res => {
        if (res.status === 1) {
          this.dialogVisible = false
          this.getTraceTemplateProductData()
          this.$message.success('设置成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 移除模板
    remove() {
      this.$confirm('此操作将移除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteTraceTemplateProduct(this.templateId).then(res => {
            console.log(res)
            if (res.status === 1) {
              this.$message.success('移除成功')
              this.isSetTemplate = false
              this.isSetShow = true
              this.activities = []
              this.traceTemplateName = ''
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除'
          })
        })
    },
    getTraceTemplateProductData() {
      getTraceTemplateProduct(this.id).then(res => {
        if (res.status === 1) {
          if (res.data.id) {
            this.templateId = res.data.id
            const arr = []
            for (let i = 0; i < res.data.list.length; i++) {
              arr.push({
                id: res.data.list[i].id,
                content: res.data.list[i].itemName,
                itemDescribe: res.data.list[i].itemDescribe,
                size: 'large',
                type: 'primary',
                color: '#409EFF'
              })
            }
            this.activities = arr
            this.traceTemplateName = res.data.traceTemplateName
            this.createTime = moment(res.data.createTime).format('YYYY-MM-DD HH:mm:ss')
            this.creatorName = res.data.creatorName
            if (res.data.updateTime) {
              this.updateTime = moment(res.data.updateTime).format('YYYY-MM-DD HH:mm:ss')
            }
            this.updatorName = res.data.updatorName
            this.isSetTemplate = true
          } else {
            this.isSetShow = true
          }
        } else {
          this.isSetShow = true
          this.$message.error(res.msg)
        }
      }).catch(res => {
        this.isSetShow = true
      })
    }
  },
  mounted() {
    this.getTraceTemplateProductData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
